import { FC, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/rootReducer';
import useAxios from '../../../hooks/useAxios';
import Loader from '../../Loader';
import ErrorResponse from '../../ErrorResponse';
import { IGetClass } from '../../../models/campusClasses.model';
import { IGetTimetables } from '../../../models/campusClasses3.model';
import { getClass } from '../../../api/campusClasses.api';
import { getTimetables } from '../../../api/campusClasses3.api';
import Record from '../../tutor/class/Record';

interface IProps {
  setTab: (tab: string) => void;
  setIsExtended: (isExtended: boolean) => void;
}

const ClassScore: FC<IProps> = ({ setTab, setIsExtended }) => {
  const { chosenClass } = useSelector((state: RootState) => state.class);
  const { data: res, isLoading, error, execute } = useAxios<IGetClass>();
  const { data: res2, isLoading: isLoading2, error: error2, execute: execute2 } = useAxios<IGetTimetables>();

  useEffect(() => {
    if (chosenClass?.classCode) {
      execute(getClass(chosenClass.classCode));
      execute2(getTimetables(chosenClass.classCode));
    }
  }, [chosenClass]);

  return (
    <>
      {isLoading || isLoading2 ? <Loader /> : null}
      <ErrorResponse error={error} />
      <ErrorResponse error={error2} />

      <Record
        classData={res?.data}
        timetables={res2?.data}
        noUseQuery
      />
    </>
  );
};

export default ClassScore;
